import Vue from 'vue';
import VueGtag from 'vue-gtag';
import VueGtm from '@gtm-support/vue2-gtm';
import Vuelidate from 'vuelidate';
import VueAnalytics from 'vue-analytics';
import VueToast from 'vue-toast-notification';

import { BootstrapVue } from 'bootstrap-vue';
import { Icon } from '@iconify/vue2';
import App from './App.vue';
import store from './store';
import router from './router';

import './libs/sentry';
import 'bootstrap';
import './styles/arcux-room.scss';

Vue.config.productionTip = false;

Vue.use(VueGtag, {
  config: { id: process.env.VUE_APP_PROJECT_GOOGLE_ANALYTICS },
}, router);

Vue.use(VueAnalytics, {
  id: process.env.VUE_APP_PROJECT_GOOGLE_ANALYTICS,
  ecommerce: {
    enabled: true,
    enhanced: true,
  },
});

Vue.use(VueGtm, {
  id: process.env.VUE_APP_PROJECT_GOOGLE_TAG_MANAGER,
});

Vue.use(VueToast);

Vue.mixin({
  methods: {
    loadGlobalScripts() {
      /* eslint-disable */
      const facebookScript = document.createElement('script');

      facebookScript.setAttribute('src', require('./libs/fb.js'));

      document.head.appendChild(facebookScript);
      /* eslint-enable */
    },
  },
});

window.arcux = {
  site: process.env.VUE_APP_SITE,
  api: `${process.env.VUE_APP_SITE}/api/v1`,
  token: (localStorage.getItem('arcux_auth_token'))
    ? localStorage.getItem('arcux_auth_token')
    : false,
  project: {
    name: process.env.VUE_APP_PROJECT_NAME,
    full: process.env.VUE_APP_PROJECT_NAME_FULL,
    support_email: process.env.VUE_APP_SUPPORT_EMAIL,
    support_refound_email: process.env.VUE_APP_SUPPORT_REFOUND_EMAIL,
    phone: process.env.VUE_APP_PROJECT_PHONE,
    facebook_name: process.env.VUE_APP_PROJECT_FB_NAME,
    menu_news: process.env.VUE_APP_PROJECT_MENU_NEWS,
    menu_live: process.env.VUE_APP_PROJECT_MENU_LIVE,
    terms: process.env.VUE_APP_PROJECT_TERMS,
    politics: process.env.VUE_APP_PROJECT_POLITICS,

    plans_link: process.env.VUE_APP_PROJECT_PLANS_LINK,
    refund: process.env.VUE_APP_PROJECT_HOTMART_REFUND,

    banner_link_temario: process.env.VUE_APP_BANNER_LINK_TEMARIO,
    banner_link_trans: process.env.VUE_APP_BANNER_LINK_TRANS,
    banner_link_secondary_temario: process.env.VUE_APP_BANNER_LINK_SECONDARY_TEMARIO,
    banner_link_secondary_trans: process.env.VUE_APP_BANNER_LINK_SECONDARY_TRANS,

    payment: {
      culqi: process.env.VUE_APP_PROJECT_CULQI_TOKEN_PUBLIC,
      paypal: process.env.VUE_APP_PROJECT_PAYPAL_TOKEN_PUBLIC,
      paypal_environment: process.env.VUE_APP_PROJECT_PAYPAL_ENVIRONMENT,
    },

    social: {
      google_app_id: process.env.VUE_APP_PROJECT_GOOGLE_APP_ID,
      facebook_app_id: process.env.VUE_APP_PROJECT_FACEBOOK_APP_ID,
    },

    metrics: {
      google_ads: `${process.env.VUE_APP_PROJECT_GOOGLE_ADWORDS}/${process.env.VUE_APP_PROJECT_GOOGLE_ADWORDS_CONVERSION}`,
      facebook_pixel: process.env.VUE_APP_PROJECT_FACEBOOK_PIXEL_ID,
    },

    welcome_page: process.env.VUE_APP_PROJECT_BUBBLE_WELCOME_PAGE,
  },
};

Vue.use(BootstrapVue);
Vue.use(Vuelidate);
Vue.component('Icon', Icon);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
